import { Button, Stack, Card, Collapse, Grid, Typography } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import api from '../Services/Api';
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import GoogleIcon from '@mui/icons-material/Google';

import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
const AccountComponent = ({user, onLogout, disconnectGmail, randomAction}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [expand, setExpand] = useState(false);
    
    function logout() {
        api.logout();
        navigate("/");
        Cookies.remove('token');
        if (onLogout) {
            onLogout();
        }
        window.location.reload();
    }

    async function connectGmail() {
        window.location.replace(`${api.baseURL}/gmail/install`)
    }


    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Stack spacing={2} style={{padding: 10}} alignItems="center">
                {user &&
                    <div style={{ width: "100%", color: 'black', textAlign: 'center', fontWeight: 'bold', color: "white" }}>
                        <h2>{user.name}</h2>
                        <h3>{user.domain}</h3>
                        <h4>{user.email}</h4>
                    </div>
                }
                {user && user.total && user.total != "" &&
                <>
                  <Card onClick={() => setExpand(!expand)} style={{  padding: "8px", borderRadius: "10px", width: "90%", maxWidth: "350px",display: "flex", flexDirection: "column"}} elevation={2}>
                      <Stack spacing={1} direction="row" alignItems="center" justifyContent="center">
                        <HourglassEmptyRoundedIcon style={{ color: "white" }} />
                        <Typography variant="body1" style={{ color: "white", fontSize: "0.9375rem", lineHeight: "26px", fontWeight: "400" }}>
                          {randomAction}
                        </Typography>
                        {expand ? <KeyboardArrowUpIcon style={{ color: "white" }} /> : <KeyboardArrowDownIcon style={{ color: "white" }} />}
                      </Stack>
                      <Collapse in={expand} orientation="vertical">
                      <Grid container spacing={1} xs={12} sm={12} md={12} lg={12} style={{ marginTop: "10px" }}>
                        {user.actions && Object.keys(user.actions).map((action) => {
                          return (
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <Stack spacing={2} direction="row" alignItems="end" justifyContent="end">
                                <Typography style={{ color: "white", fontSize: "14px", fontWeight: "400" }}>
                                  {t(user.actions[action].label)}:
                                </Typography>
                                <Typography style={{ color: "#2E7D32", fontSize: "14px", fontWeight: "700" }}>
                                  {user.actions[action].minutes} {t('min')}
                                </Typography>
                              </Stack>
                            </Grid>
                          )
                        })}
                      </Grid>
                      </Collapse>
                    </Card>
                </>
              }
                {user.gmail == false && <Button variant="contained" style={{fontSize: "1rem"}} color="primary" onClick={() => {connectGmail()}}><GoogleIcon style={{marginRight: "5px"}}/> {t('connectGmail')}</Button>}
                {user.gmail == true && <Button color="error" style={{fontSize: "1rem", border: "1px solid", borderRadius: "100px"}} onClick={() => {disconnectGmail()}}><GoogleIcon style={{marginRight: "5px"}} /> {t('disconnectGmail')}</Button>}
                <Button variant="contained" color="error" onClick={() => {logout()}}>{t('logout')}</Button>
            </Stack>
        </div>
    );
}

export default AccountComponent;